import React from "react";
import { siteData } from "../mock";
import SignupForm from "./SignupForm";
import SignupSuccess from "./SignupSuccess";
import { useSignupForm } from "../hooks/useSignupForm";

const FinalCta = () => {
  const { finalCta, hero } = siteData;
  const { form, submitting, handleChange, submit, lastResult, clearSuccess } =
    useSignupForm({
      source: "final_cta",
      successMessage: "Welcome. Take a seat. We're glad you're here.",
    });

  const handleSubmit = (e) => {
    e.preventDefault();
    submit();
  };

  return (
    <section
      className="relative isolate overflow-hidden text-white"
      style={{
        backgroundImage: `url(${hero.heroBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="absolute inset-0 ht-final-overlay" />
      <div className="absolute inset-0 ht-grain opacity-50" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 py-24 lg:py-32">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div>
            <h2 className="ht-display text-3xl sm:text-4xl lg:text-5xl leading-[1.1]">
              {finalCta.title}
            </h2>
            <p className="mt-6 ht-body text-white/80 text-base sm:text-lg leading-relaxed">
              {finalCta.bodyOne}
            </p>
            <p className="mt-4 ht-body text-white/80 text-base sm:text-lg leading-relaxed">
              {finalCta.bodyTwo}
            </p>
            <p className="mt-6 ht-body font-semibold text-white">
              {finalCta.closer}
            </p>
          </div>

          <div className="lg:max-w-md lg:ml-auto w-full">
            {lastResult ? (
              <div className="rounded-2xl bg-white/10 border border-white/20 backdrop-blur-sm p-6 sm:p-8">
                <SignupSuccess
                  firstName={lastResult.firstName}
                  alreadyMember={lastResult.alreadyMember}
                  onSignAnother={clearSuccess}
                  variant="on-dark"
                />
              </div>
            ) : (
              <SignupForm
                form={form}
                submitting={submitting}
                onChange={handleChange}
                onSubmit={handleSubmit}
                ctaLabel={finalCta.cta}
                inputVariant="on-dark"
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCta;
